<template lang="pug">
v-card
    v-card-title Toluna Banner Manager
    v-card-text
        v-data-table(
            :headers="headers"
            :items="desserts"
            hide-default-footer
        )
            template(v-slot:item.id="{ item }")
                b Banner \#{{ item.id + 1 }}

            template(v-slot:item.show="{ item }")
                v-checkbox(
                    label="Show / Hide"
                    v-model="desserts[item.id].show"
                )

            template(v-slot:item.image="{ item }")
                img(v-if="item.image" :src="item.image" :width="300")

            template(v-slot:item.url="{ item }")
                v-text-field(
                    v-model="desserts[item.id].name"
                    :disabled="item.loading"
                    placeholder="Banner Name"
                    prepend-icon="mdi-rename"
                )
                v-file-input(
                    v-model="item.image_form"
                    :disabled="item.loading"
                    placeholder="Select Image"
                ) Select File
                v-text-field(
                    v-model="desserts[item.id].url"
                    :disabled="item.loading"
                    placeholder="Banner URL"
                    prepend-icon="mdi-link-variant"
                )

            template(v-slot:item.actions="{ item }")
                v-btn(
                    small
                    color="blue-grey"
                    class="ma-2 white--text"
                    :disabled="item.loading"
                    @click="onSave(item.id)"
                ) Save

    v-snackbar(v-model="success" top color="green")
        v-icon(left) mdi-alert-circle-outline
        | Successfully Saved!
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="success = false"
            ) Close

    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
        
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Config from '../../../configuration';

export default {
    data() {
        return {
            success: false,
            loading: true,
            error: {
                show: false,
                message: ''
            },
            form: {
                spotifyImage: null,
                spotufyLink: null
            },
            headers: [
                { text: '#No.', align: 'start', value: 'id' },
                { text: '', align: 'start', value: 'show' },
                { text: 'Image', value: 'image', align: 'center' },
                { text: 'Form', value: 'url' },
                { text: 'Actions', align: 'end', value: 'actions' }
            ],
            desserts: [
                {
                    id: 0,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 1,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 2,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 3,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 4,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 5,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 6,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 7,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
                {
                    id: 8,
                    show: false,
                    name: '',
                    image: null,
                    image_form: null,
                    url: null,
                    loading: false
                },
            ]
        };
    },
    computed: {
        ...mapGetters('bh-settings', { settings: 'find' })
    },
    async created() {
        await this.getSettings({
            query: {
                option_name: { $in: [
                    'mobile_mini_banner_name_1', 'mobile_mini_banner_show_1', 'mobile_mini_banner_image_1', 'mobile_mini_banner_url_1',
                    'mobile_mini_banner_name_2', 'mobile_mini_banner_show_2', 'mobile_mini_banner_image_2', 'mobile_mini_banner_url_2',
                    'mobile_mini_banner_name_3', 'mobile_mini_banner_show_3', 'mobile_mini_banner_image_3', 'mobile_mini_banner_url_3',
                    'mobile_mini_banner_name_4', 'mobile_mini_banner_show_4', 'mobile_mini_banner_image_4', 'mobile_mini_banner_url_4',
                    'mobile_mini_banner_name_5', 'mobile_mini_banner_show_5', 'mobile_mini_banner_image_5', 'mobile_mini_banner_url_5',
                    'mobile_mini_banner_name_6', 'mobile_mini_banner_show_6', 'mobile_mini_banner_image_6', 'mobile_mini_banner_url_6',
                    'mobile_mini_banner_name_7', 'mobile_mini_banner_show_7', 'mobile_mini_banner_image_7', 'mobile_mini_banner_url_7',
                    'mobile_mini_banner_name_8', 'mobile_mini_banner_show_8', 'mobile_mini_banner_image_8', 'mobile_mini_banner_url_8',
                    'mobile_mini_banner_name_9', 'mobile_mini_banner_show_9', 'mobile_mini_banner_image_9', 'mobile_mini_banner_url_9',
                ] },
                $limit: 100
            }
        });
        this.form.spotufyLink = this.profileSideBarLink;
        this.loading = false;

        this.desserts.map(async (item) => {
            this.desserts[item.id].name = await this.checkAndCreate(`mobile_mini_banner_name_${item.id + 1}`);
            this.desserts[item.id].show = parseInt(await this.checkAndCreate(`mobile_mini_banner_show_${item.id + 1}`)) === 1;
            this.desserts[item.id].image = await this.checkAndCreate(`mobile_mini_banner_image_${item.id + 1}`);
            this.desserts[item.id].url = await this.checkAndCreate(`mobile_mini_banner_url_${item.id + 1}`);
        });
    },
    methods: {
        async checkAndCreate(option_name) {
            if(this.getOptions(option_name) === null)
                await this.createSettings({ option_name });
            return this.getOptions(option_name).option_value;
        },
        getOptions(option_name) {
            const settings = this.settings({
                query: { option_name }
            });
            return settings.total !== 0 ? settings.data[0] : null;
        },

        async onSave(index) {
            try {
                this.desserts[index].loading = true;
                if(this.desserts[index].image_form) {
                    const profilePictureRaw = await this.toBase64(this.desserts[index].image_form);
                    const profileS3File = await fetch(`${Config.host}/api/upload`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': window.localStorage.getItem('feathers-jwt')
                        },
                        body: JSON.stringify({
                            uri: profilePictureRaw
                        })
                    }).then(data => data.json());

                    const settingsImage = this.getOptions(`mobile_mini_banner_image_${index+1}`);
                    settingsImage.option_value = `https://api.breakinghits.com/public/${profileS3File.id}`;
                    this.desserts[index].image = `https://api.breakinghits.com/public/${profileS3File.id}`;
                    this.desserts[index].image_form = null;
                    await settingsImage.patch();
                }

                const settingsName = this.getOptions(`mobile_mini_banner_name_${index+1}`);
                settingsName.option_value = this.desserts[index].name;
                await settingsName.patch();

                const settingsShow = this.getOptions(`mobile_mini_banner_show_${index+1}`);
                settingsShow.option_value = this.desserts[index].show ? 1 : 0;
                await settingsShow.patch();

                const settingsUrl = this.getOptions(`mobile_mini_banner_url_${index+1}`);
                settingsUrl.option_value = this.desserts[index].url;
                await settingsUrl.patch();

                this.success = true;
            } catch(err) {
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.desserts[index].loading = false;
            }
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        ...mapActions('bh-settings', { getSettings: 'find', createSettings: 'create' })
    }
}
</script>

<style lang="scss" scoped>
.holder {
    max-width: 710px;
}
</style>